"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToNQError = exports.statusModelToNqError = void 0;
var ajax_1 = require("rxjs/ajax");
var NQError_1 = require("../NQError");
function statusModelToNqError(statusModel) {
    switch (statusModel.code) {
        case 0:
            return new NQError_1.NQError(NQError_1.NQErrorCode.Client, statusModel.message);
        case 428:
            return new NQError_1.NQError(NQError_1.NQErrorCode.ParallelSpeedtests, statusModel.message);
        case 429:
            return new NQError_1.NQError(NQError_1.NQErrorCode.RateLimit, statusModel.message);
        default:
            return new NQError_1.NQError(NQError_1.NQErrorCode.Server, statusModel.message);
    }
}
exports.statusModelToNqError = statusModelToNqError;
function convertToNQError(error) {
    var nqError;
    if (error instanceof Event) {
        nqError = convertEventToNQError(error);
    }
    else if (typeof Response !== "undefined" && error instanceof Response) {
        nqError = convertResponseToNQError(error);
    }
    else if (error instanceof NQError_1.NQError) {
        nqError = error;
    }
    else if (error instanceof NQError_1.NQInternalError) {
        var code = void 0;
        switch (error.internalCode) {
            case NQError_1.NQInternalErrorCode.RemotePortDetection:
                code = NQError_1.NQErrorCode.Server;
                break;
            case NQError_1.NQInternalErrorCode.MissingNQValueDuringSave:
            case NQError_1.NQInternalErrorCode.IllegalBenchmarkResultsValues:
                code = NQError_1.NQErrorCode.Client;
                break;
            case NQError_1.NQInternalErrorCode.DownloadError:
            case NQError_1.NQInternalErrorCode.DownloadTimeout:
            case NQError_1.NQInternalErrorCode.UploadError:
            case NQError_1.NQInternalErrorCode.UploadTimeout:
                code = NQError_1.NQErrorCode.Connectivity;
                break;
        }
        nqError = new NQError_1.NQError(code, null, error);
    }
    else if (error instanceof DOMException) {
        nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Client, error.message, error);
    }
    else if (error instanceof TypeError) {
        nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Client, error.message, error);
    }
    else if (error instanceof ajax_1.AjaxError) {
        nqError = convertAjaxErrorToNQError(error);
    }
    else if (error instanceof Error) {
        nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Client, error.message, error);
    }
    else {
        debugger;
        nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Client, "Unknown error", error);
    }
    return nqError;
}
exports.convertToNQError = convertToNQError;
function convertAjaxErrorToNQError(error) {
    var nqError;
    if (error instanceof ajax_1.AjaxTimeoutError) {
        nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity, error.message, error);
    }
    else {
        switch (error.status) {
            case 0:
                nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity, error.message, error);
                break;
            case 200:
                nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Client, error.message, error);
                break;
            default:
                nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Server, error.message, error);
                break;
        }
    }
    return nqError;
}
function convertEventToNQError(ev) {
    var nqError;
    switch (ev.type) {
        case "error":
            nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity, "Event.type = ".concat(ev.type), null);
            break;
        case "timeout":
            nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity, "Event.type = ".concat(ev.type), null);
            break;
        default:
            nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity, "Unknown XHR error. Event.type = ".concat(ev.type), null);
            break;
    }
    return nqError;
}
function convertResponseToNQError(error) {
    var nqError;
    if (error.status >= 400 && error.status < 500) {
        nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Client, error.statusText);
    }
    else if (error.status >= 500 && error.status < 600) {
        nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Server, error.statusText);
    }
    else {
        nqError = new NQError_1.NQError(NQError_1.NQErrorCode.Client, "Unknown error with code ".concat(error.status, ": \"").concat(error.statusText, "\""));
    }
    return nqError;
}
//# sourceMappingURL=convertToNQError.js.map